import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { FormattedDate, injectIntl } from 'react-intl'

const TreatmentDate = ({date, intl}) => {
    return(
        <Grid
            data-testid="treatment-date"
            item style={{paddingBottom: '12px'}}>
            <Typography data-testid="treatment-date-label">{intl.formatMessage({id: 'app.caseDetail.treatmentLabel'})}</Typography>
            <FormattedDate year='numeric' month='short' day='2-digit' data-testid="treatment-date-input" value={date}></FormattedDate>
        </Grid>
    )
}
export default injectIntl(TreatmentDate)